<template>
  <div class="page-listings">
    <section class="py-5 banner-bg bs-shadow mobile-top">
      <div class="container">
        <div style="display: flex">
          <h1 class="text-white mb0 lh1">Product School Registration</h1>
          <a data-v-0f710401="" v-if="$store.getters.isSpacesaverEmployee" href="/product-school-registrants" class="search" style="min-width: 120px; padding-left: 10px; margin-left: auto; color: fff; text-decoration: none;">Registrants <i data-v-0f710401="" class="material-icons">keyboard_arrow_right</i></a>
        </div>
        <hr class="header-divide" />
        <div class="search-btns">
          <div class="left-side" style="margin-right: 20px">
            <h5 class="text-white" style="margin-bottom: 10px">
              Product School (In Person) includes:
            </h5>
            <div class="row">
              <div class="col-xs-12 col-md-6 col-12">
                <ul class="text-white mb0">
                  <li>Standard Mobile</li>
                  <li>Wheelhouse</li>
                  <li>Powered Mobile</li>
                  <li>ActivRAC</li>
                  <li>RaptorRAC</li>
                  <li>XTend, High Bay</li>
                  <li>Shelving - Cantilever, FrameWRX, EZ Rail, WRX Wheels</li>
                  <li>Museum Cabinets & Cantilever Racks</li>
                </ul>
              </div>
              <div class="col-xs-12 col-md-6 col-12">
                <ul class="text-white">
                  <li>Art Racks</li>
                  <li>
                    Lockers – FreeStyle, Rival, Evidence, ControLoc, Tactical
                    Readiness, Gun Boxes
                  </li>
                  <li>Day Use Lockers</li>
                  <li>Weapon Racks</li>
                  <li>
                    Deployables – Tricon, Rapid Readiness Box, Parachute
                    Containers
                  </li>
                  <li>Grow Products</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="ScrollTarget" class="py-5 bs-shadow mobile-top">
      <div class="container">
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="500"
          mode="out-in"
          appear
        >
          <div>
            <div class="step1" key="step1">
              <div class="listing">
                <h3 class="text-base/10 font-semibold text-gray-900">
                  Please complete the following registration form.
                </h3>
                <p style="margin-bottom: 20px">
                  We would appreciate your response as soon as possible in order
                  to process the information prior to the training session.
                </p>
                <hr />
             
                  <div class="row">
                    <div class="col-xs-12 col-md-6 col-12">
                      <div class="form-group">
    <label for="productSchoolDate">* Upcoming Product School Dates</label>
    <select
      id="productSchoolDate"
      name="productSchoolDate"
      class="form-control custom-select product-school-select"
      v-model="form.selectedDate"
      :class="{ 'is-invalid': errors.selectedDate }"
      :aria-invalid="errors.selectedDate ? 'true' : 'false'"
      required
      v-if="!loading && filteredSessions.length"
    >
      <option value="" disabled>Select a Date</option>
      <option
        v-for="date in filteredSessions"
        :key="date.ID"
        :value="date.StartDate"
        :disabled="date.AttendanceCount >= AttendanceLimit"
      >
        {{ date.Description }}
      </option>
    </select>
    <div class="invalid-feedback" v-if="errors.selectedDate">
      {{ errors.selectedDate }}
    </div>
    <div v-if="form.selectedDate && selectedSession" class="spots-info mt-2">
      {{ spotsLeft }} spot{{ spotsLeft !== 1 ? 's' : '' }} left for this session
    </div>
    <div v-if="!loading && !filteredSessions.length" class="no-sessions mt-2">
      No available sessions at this time.
    </div>
  </div>

                      <div class="form-group">
                        <label for="firstName">* First Name</label>
                        <input
                          type="text"
                          id="firstName"
                          class="form-control"
                          placeholder="Enter First Name"
                          v-model="form.firstName"
                          :class="{ 'is-invalid': errors.firstName }"
                          :aria-invalid="errors.firstName ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.firstName">
                          {{ errors.firstName }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="lastName">* Last Name</label>
                        <input
                          type="text"
                          id="lastName"
                          class="form-control"
                          placeholder="Enter Last Name"
                          v-model="form.lastName"
                          :class="{ 'is-invalid': errors.lastName }"
                          :aria-invalid="errors.lastName ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.lastName">
                          {{ errors.lastName }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="namePreference">* Name Preference</label>
                        <input
                          type="text"
                          id="namePreference"
                          class="form-control"
                          placeholder="Enter Name Preference"
                          v-model="form.namePreference"
                          :class="{ 'is-invalid': errors.namePreference }"
                          :aria-invalid="
                            errors.namePreference ? 'true' : 'false'
                          "
                          required
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.namePreference"
                        >
                          {{ errors.namePreference }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="jobTitle">* Job Title</label>
                        <input
                          type="text"
                          id="jobTitle"
                          class="form-control"
                          placeholder="Enter Job Title"
                          v-model="form.jobTitle"
                          :class="{ 'is-invalid': errors.jobTitle }"
                          :aria-invalid="errors.jobTitle ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.jobTitle">
                          {{ errors.jobTitle }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="phoneNumber">Phone Number</label>
                        <input
                          type="tel"
                          id="phoneNumber"
                          class="form-control"
                          placeholder="Enter Phone Number"
                          v-model="form.phoneNumber"
                          :class="{ 'is-invalid': errors.phoneNumber }"
                          :aria-invalid="errors.phoneNumber ? 'true' : 'false'"
                        />
                        <div class="invalid-feedback" v-if="errors.phoneNumber">
                          {{ errors.phoneNumber }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="email">* Email</label>
                        <input
                          type="email"
                          id="email"
                          class="form-control"
                          placeholder="Enter Email"
                          v-model="form.email"
                          :class="{ 'is-invalid': errors.email }"
                          :aria-invalid="errors.email ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.email">
                          {{ errors.email }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="company">* Company</label>
                        <input
                          type="text"
                          id="company"
                          class="form-control"
                          placeholder="Enter Company Name"
                          v-model="form.company"
                          :class="{ 'is-invalid': errors.company }"
                          :aria-invalid="errors.company ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.company">
                          {{ errors.company }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="companyAddress"
                          >* Company Street Address</label
                        >
                        <textarea
                          id="companyAddress"
                          class="form-control"
                          rows="1"
                          placeholder="Enter Street Address..."
                          v-model="form.companyAddress"
                          :class="{ 'is-invalid': errors.companyAddress }"
                          :aria-invalid="
                            errors.companyAddress ? 'true' : 'false'
                          "
                          required
                        ></textarea>
                        <div
                          class="invalid-feedback"
                          v-if="errors.companyAddress"
                        >
                          {{ errors.companyAddress }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="companyCity">* Company City</label>
                        <input
                          type="text"
                          id="companyCity"
                          class="form-control"
                          placeholder="Enter City"
                          v-model="form.companyCity"
                          :class="{ 'is-invalid': errors.companyCity }"
                          :aria-invalid="errors.companyCity ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.companyCity">
                          {{ errors.companyCity }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="companyState">* Company State</label>
                        <input
                          type="text"
                          id="companyState"
                          class="form-control"
                          placeholder="Enter State"
                          v-model="form.companyState"
                          :class="{ 'is-invalid': errors.companyState }"
                          :aria-invalid="errors.companyState ? 'true' : 'false'"
                          @input="
                            form.companyState = $event.target.value.toUpperCase()
                          "
                          required
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.companyState"
                        >
                          {{ errors.companyState }}
                        </div>
                      </div>
                    </div>

                    <div class="col-xs-12 col-md-6 col-12">
                      

                      <div class="form-group">
                        <label for="companyZip">* Company Zip Code</label>
                        <input
                          type="text"
                          id="companyZip"
                          class="form-control"
                          placeholder="Enter Zip Code"
                          v-model="form.companyZip"
                          :class="{ 'is-invalid': errors.companyZip }"
                          :aria-invalid="errors.companyZip ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.companyZip">
                          {{ errors.companyZip }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="country">* Country</label>
                        <select
                          id="country"
                          name="country"
                          class="form-control custom-select"
                          v-model="form.country"
                          :class="{ 'is-invalid': errors.country }"
                          :aria-invalid="errors.country ? 'true' : 'false'"
                          required
                        >
                          <option value="United States">United States</option>
                          <option value="Canada">Canada</option>
                          <option value="Mexico">Mexico</option>
                          <option value="United Kingdom & Europe">United Kingdom & Europe</option>
                          <option value="Central America">Central America</option>
                          <option value="Australia">Australia</option>
                          <option value="Asia/Middle East">Asia/Middle East</option>
                          <option value="Bermuda">Bermuda</option>
                          <option value="Puerto Rico">Puerto Rico</option>
                          <option value="Cayman Islands">Cayman Islands</option>
                          <option value="Dubai">Dubai</option>
                          <option value="Hong Kong">Hong Kong</option>
                          <option value="Trinidad & Tabago">Trinidad & Tabago</option>
                          









                        </select>
                        <div class="invalid-feedback" v-if="errors.country">
                          {{ errors.country }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="tenure"
                          >* How long have you worked for
                          {{ form.company || 'your company' }}?</label
                        >
                        <input
                          type="text"
                          id="tenure"
                          class="form-control"
                          placeholder="Enter time in role"
                          v-model="form.tenure"
                          :class="{ 'is-invalid': errors.tenure }"
                          :aria-invalid="errors.tenure ? 'true' : 'false'"
                          required
                        />
                        <div class="invalid-feedback" v-if="errors.tenure">
                          {{ errors.tenure }}
                        </div>
                      </div>


                      <div class="form-group">
                        <label
                          >* Are you a full-time employee at {{form.company}}?</label
                        >
                        <div
                          class="myTest custom-control custom-checkbox form-control-lg"
                          style="display: flex; align-items: center"
                        >
                          <input
                            type="checkbox"
                            id="isFulltime"
                            class="custom-control-input form-control-lg"
                            v-model="form.isFullTime"
                          />
                          <label
                            class="custom-control-label"
                            for="isFulltime"
                          >
                            <small class="form-text text-muted">Yes</small>
                          </label>
                        </div>
                      </div>

                      

                      <div class="form-group">
                        <label
                          >* Have you worked for any competitors of
                          Spacesaver?</label
                        >
                        <div
                          class="myTest custom-control custom-checkbox form-control-lg"
                          style="display: flex; align-items: center"
                        >
                          <input
                            type="checkbox"
                            id="hasWorkedForCompetitors"
                            class="custom-control-input form-control-lg"
                            v-model="form.hasWorkedForCompetitors"
                          />
                          <label
                            class="custom-control-label"
                            for="hasWorkedForCompetitors"
                          >
                            <small class="form-text text-muted">Yes</small>
                          </label>
                        </div>
                      </div>

                      <div
                        v-if="form.hasWorkedForCompetitors"
                        class="form-group"
                      >
                        <label for="competitorName"
                          >Which competitors have you worked for?</label
                        >
                        <input
                          type="text"
                          id="competitorName"
                          class="form-control"
                          placeholder="Enter competitor name"
                          v-model="form.competitorName"
                          :class="{ 'is-invalid': errors.competitorName }"
                          :aria-invalid="
                            errors.competitorName ? 'true' : 'false'
                          "
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.competitorName"
                        >
                          {{ errors.competitorName }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label>* Check here if no hotel is required</label>
                        <div
                          class="myTest custom-control custom-checkbox form-control-lg"
                          style="display: flex; align-items: center"
                        >
                          <input
                            type="checkbox"
                            id="noHotelRequired"
                            class="custom-control-input form-control-lg"
                            v-model="form.noHotelRequired"
                          />
                          <label
                            class="custom-control-label"
                            for="noHotelRequired"
                          >
                            <small class="form-text text-muted"
                              >No hotel is required</small
                            >
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <label
                          >* Do you have any special dietary
                          requirements?</label
                        >
                        <div
                          class="myTest custom-control custom-checkbox form-control-lg"
                          style="display: flex; align-items: center"
                        >
                          <input
                            type="checkbox"
                            id="hasDietaryRestrictions"
                            class="custom-control-input form-control-lg"
                            v-model="form.hasDietaryRestrictions"
                          />
                          <label
                            class="custom-control-label"
                            for="hasDietaryRestrictions"
                          >
                            <small class="form-text text-muted">Yes</small>
                          </label>
                        </div>
                      </div>

                      <div
                        v-if="form.hasDietaryRestrictions"
                        class="form-group"
                      >
                        <label for="dietaryRequirement"
                          >What are your dietary requirements?</label
                        >
                        <input
                          type="text"
                          id="dietaryRequirement"
                          class="form-control"
                          placeholder="Enter dietary requirements"
                          v-model="form.dietaryRequirement"
                          :class="{ 'is-invalid': errors.dietaryRequirement }"
                          :aria-invalid="
                            errors.dietaryRequirement ? 'true' : 'false'
                          "
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.dietaryRequirement"
                        >
                          {{ errors.dietaryRequirement }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="arrivalDate"
                          >* Planned Arrival Date & Time</label
                        >
                        <VueDatePicker
                          id="arrivalDate"
                          v-model="form.arrivalDate"
                          :enable-time-picker="true"
                          format="MMM dd yyyy, hh:mm a"
                          input-class-name="dp-custom-input"
                          placeholder="Select Arrival Date & Time"
                          wrapper-class="datepicker1"
                          :typeable="true"
                          :class="{ 'is-invalid': errors.arrivalDate }"
                          :aria-invalid="errors.arrivalDate ? 'true' : 'false'"
                        />
                        <div class="invalid-feedback" v-if="errors.arrivalDate">
                          {{ errors.arrivalDate }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="departureDate"
                          >* Planned Departure Date & Time</label
                        >
                        <VueDatePicker
                          id="departureDate"
                          v-model="form.departureDate"
                          :enable-time-picker="true"
                          format="MMM dd yyyy, hh:mm a"
                          input-class-name="dp-custom-input"
                          placeholder="Select Departure Date & Time"
                          wrapper-class="datepicker1"
                          :typeable="true"
                          :class="{ 'is-invalid': errors.departureDate }"
                          :aria-invalid="errors.departureDate ? 'true' : 'false'"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.departureDate"
                        >
                          {{ errors.departureDate }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="country">* Golf Shirt/Polo Size</label>
                        <select
                          id="shirt"
                          name="shirt"
                          class="form-control custom-select"
                          v-model="form.shirt"
                          :class="{ 'is-invalid': errors.shirt }"
                          :aria-invalid="errors.shirt ? 'true' : 'false'"
                          required
                        >
                          <option value="Womens S">Womens S</option>
                          <option value="Womens M">Womens M</option>
                          <option value="Womens L">Womens L</option>
                          <option value="Womens XL">Womens XL</option>
                          <option value="Womens 2XL">Womens 2XL</option>
                          <option value="Womens 3X">Womens 3XL</option>
                          <option value="Womens 4XL">Womens 4XL</option>
                          <option value="Mens S">Mens S</option>
                          <option value="Mens M">Mens M</option>
                          <option value="Mens L">Mens L</option>
                          <option value="Mens XL">Mens XL</option>
                          <option value="Mens 2XL">Mens 2XL</option>
                          <option value="Mens 3XL">Mens 3XL</option>
                          <option value="Mens 4XL">Mens 4XL</option>
                        </select>
                        <div class="invalid-feedback" v-if="errors.shirt">
                          {{ errors.shirt }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-12">
                      <div
                        class="nav-btns listing-header d-flex align-items-center mt10 mb10 rounded b-shadow"
                      >
                        <button
                          @click="submitForm"
                          class="mlauto"
                          :disabled="isSubmitting"
                        >
                          {{ isSubmitting ? 'Submitting...' : 'Submit' }}
                          <i class="material-icons">keyboard_arrow_right</i>
                        </button>
                      </div>
                    </div>
                  </div>
        
              </div>
            </div>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import VueDatePicker from '@vuepic/vue-datepicker';
import { jwtDecode } from 'jwt-decode';
import '@vuepic/vue-datepicker/dist/main.css';

const auth = {
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('SSCUSER'),
  },
};

export default {
  name: 'ProductSchoolRegistration',
  components: {
    VueDatePicker,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      backend: import.meta.env.VITE_APP_SERVER_URL,
      // backend: 'http://localhost:5002',
      dates: ['2025-04-01', '2025-06-10', '2025-09-23'],
      sessions: null,
      AttendanceLimit: 18,
      form: {
        selectedDate: '',
        firstName: '',
        lastName: '',
        namePreference: '',
        jobTitle: '',
        phoneNumber: '',
        email: '',
        company: '',
        companyAddress: '',
        companyCity: '',
        companyState: '',
        companyZip: '',
        country: 'United States',
        tenure: '',
        hasWorkedForCompetitors: false,
        competitorName: '',
        noHotelRequired: false,
        hasDietaryRestrictions: false,
        dietaryRequirement: '',
        arrivalDate: null,
        departureDate: null,
        RepID: null,
        ACID: null,
        UserID: null,
        shirt:'Womens S'
      },
      errors: {
        selectedDate: "",
      },
      isSubmitting: false,
      loading: true,
      acs: [],
      salespeople: [],
      productTypes: [],
      acList: [],
    };
  },
  methods: {
    getUserInfo() {
      const token = localStorage.getItem('SSCUSER');

      if (token) {
        const decoded = jwtDecode(token);
        console.log(decoded)
        this.form.firstName = decoded.FirstName || '';
        this.form.lastName = decoded.LastName || '';
        this.form.email = decoded.Email || '';
        this.form.RepID = decoded.RepId;
        this.form.company = decoded.Company || '';
        this.form.ACID = decoded.CompanyID;
        this.form.UserID = decoded.UserId;
        ;
      }
      
    },
    scrollToFirstError() {
      const firstError = document.querySelector('.is-invalid');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstError.focus();
      }
    },
    firstLoad() {
      this.getUserInfo();
      this.loading = true;
      this.$store.commit('setActivePage', 'order-manage');

   
      return axios
        .get(`${this.backend}/api/v1/product-school-sessions`, auth)
        .then(response => {
          console.log(response);
          if (response.status === 401) {
              this.$router.push("/");
          } else {
            console.log(response.data)
            this.sessions = response.data.data;   
            this.loading = false; 
          }
              
        })
        .catch(error => {
          console.error('Error in firstLoad:', error.response.status);
          if (error.response.status === 401) {
              this.$router.push("/");
          }
          this.loading = false;
        });
     
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    },

    validateForm() {
      // alert("here")
      this.errors = {};
      let isValid = true;

      if (!this.form.selectedDate) {
        this.errors.selectedDate = 'Please select a date';
        isValid = false;
      }
      if (!this.form.firstName.trim()) {
        this.errors.firstName = 'First name is required';
        isValid = false;
      }
      if (!this.form.lastName.trim()) {
        this.errors.lastName = 'Last name is required';
        isValid = false;
      }

      if (!this.form.namePreference.trim()) {
        this.errors.namePreference = 'Name preference is required';
        isValid = false;
      }

      if (!this.form.jobTitle.trim()) {
        this.errors.jobTitle = 'Job title is required';
        isValid = false;
      }

      if (!this.form.email.trim()) {
        this.errors.email = 'Email is required';
        isValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        this.errors.email = 'Please enter a valid email address';
        isValid = false;
      }

      if (!this.form.company.trim()) {
        this.errors.company = 'Company name is required';
        isValid = false;
      }

      if (!this.form.companyAddress.trim()) {
        this.errors.companyAddress = 'Company address is required';
        isValid = false;
      }

      if (!this.form.companyCity.trim()) {
        this.errors.companyCity = 'Company city is required';
        isValid = false;
      }

      if (!this.form.companyState.trim()) {
        this.errors.companyState = 'Company state is required';
        isValid = false;
      }

      if (!this.form.companyZip.trim()) {
        this.errors.companyZip = 'Company zip code is required';
        isValid = false;
      } 

      if (!this.form.country) {
        this.errors.country = 'Country is required';
        isValid = false;
      }

      if (!this.form.shirt) {
        this.errors.shirt = 'Shirt size is required';
        isValid = false;
      }

      if (!this.form.tenure.trim()) {
        this.errors.tenure = 'Time in role is required';
        isValid = false;
      }

      if (
        this.form.hasWorkedForCompetitors &&
        !this.form.competitorName.trim()
      ) {
        this.errors.competitorName = 'Please specify competitor names';
        isValid = false;
      }

      if (
        this.form.hasDietaryRestrictions &&
        !this.form.dietaryRequirement.trim()
      ) {
        this.errors.dietaryRequirement = 'Please specify dietary requirements';
        isValid = false;
      }

      if (!this.form.arrivalDate) {
        this.errors.arrivalDate = 'Arrival date is required';
        isValid = false;
      }

      if (!this.form.departureDate) {
        this.errors.departureDate = 'Departure date is required';
        isValid = false;
      }

      if (
        !this.form.phoneNumber &&
        !/^\+?1?\d{10,15}$/.test(this.form.phoneNumber.replace(/\D/g, ''))
      ) {
        this.errors.phoneNumber = 'Please enter a valid phone number';
        isValid = false;
      }

      if (!isValid) {
        this.$nextTick(() => this.scrollToFirstError());
      }

      return isValid;
    },



    submitForm() {
      console.log('Form data:', this.form);
      if (!this.validateForm()) {
        console.log('Form is invalid:', this.errors);
        return;
      }

      // Uncomment the following to enable backend submission
      
      this.isSubmitting = true;
      axios
        .post(
          `${this.backend}/api/v1/product-school-signup`,
          {
            date: this.form.selectedDate,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            namePreference: this.form.namePreference,
            jobTitle: this.form.jobTitle,
            phoneNumber: this.form.phoneNumber,
            email: this.form.email,
            company: this.form.company,
            companyAddress: this.form.companyAddress,
            companyCity: this.form.companyCity,
            companyState: this.form.companyState,
            companyZip: this.form.companyZip,
            country: this.form.country,
            shirt: this.form.shirt,
            tenure: this.form.tenure,
            hasWorkedForCompetitors: this.form.hasWorkedForCompetitors,
            competitorName: this.form.competitorName,
            noHotelRequired: this.form.noHotelRequired,
            hasDietaryRestrictions: this.form.hasDietaryRestrictions,
            dietaryRequirement: this.form.dietaryRequirement,
            arrivalDate: this.form.arrivalDate,
            departureDate: this.form.departureDate,
            ACID: this.form.ACID,
            isFullTime: this.form.isFullTime,
            RepID: this.form.RepID,
            UserID: this.form.UserID,
          },
          auth
        )
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            this.$toast.success("Successfully created your reservation!");
            this.$router.push(`/product-school-info`);
            // alert('Registration submitted successfully!');

            /*
            Object.keys(this.form).forEach(key => {
              if (typeof this.form[key] === 'boolean') {
                this.form[key] = false;
              } else if (key === 'country') {
                this.form[key] = 'United States';
              } else {
                this.form[key] =
                  key === 'arrivalDate' || key === 'departureDate'
                    ? null
                    : key === 'RepId' || key === 'ACID'
                    ? this.form[key]
                    : '';
              }
            });
            */
            this.errors = {};
          }
        })
        .catch(error => {
          console.error('Error submitting registration:', error);
          alert(
            'An error occurred while submitting your registration. Please try again.'
          );
        })
        .finally(() => {
          this.isSubmitting = false;
        });
      
    },
  },
  computed: {
    filteredSessions() {
   
      
      if (!this.loading && this.sessions?.length) {
        const now = new Date();
        const thirtyDaysFromNow = new Date(now);
        thirtyDaysFromNow.setDate(now.getDate() + 30);   // adds 30 calendar days

        return this.sessions.filter((session) => {
          const startDate = new Date(session.StartDate);
          return (
            startDate >= now &&                           // not in the past
            startDate >= thirtyDaysFromNow &&             // within next 30 days
            session.AttendanceCount < this.AttendanceLimit
          );
        });
      }
       
        
 
     
      /*
      return this.sessions.filter((session) => {
        return session.AttendanceCount < this.AttendanceLimit
      });
       */
    
    },
    selectedSession() {
      return this.sessions.find(
        (session) => session.StartDate === this.form.selectedDate
      );
    },
    spotsLeft() {
      if (!this.selectedSession) return 0;
      return this.AttendanceLimit - this.selectedSession.AttendanceCount;
    },
    activeNav() {
      return this.$store.state.activePage;
    },
    states() {
      return new Set(this.acList.map(x => x.State).sort());
    },
  },
  created() {
    this.$store.commit('showNavigation');
  },
  mounted() {
    this.firstLoad();
  },
};
</script>


  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
#pickDate1 input {
  border: 0 !important;
  outline: none !important;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.leadTime {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.leadTime-bottom {
  align-items: flex-end;
}
.leadTime-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: none;
}

.listing {
  background-color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
.header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.table-striped td:last-of-type {
  text-align: right;
}
.table-striped th:last-of-type {
  text-align: right;
}
.table-bordered td:first-of-type {
  border-right: none !important;
}
.table-bordered th:first-of-type {
  border-right: none !important;
}
.table-bordered td:last-of-type {
  border-left: none !important;
}
.table-bordered th:last-of-type {
  border-left: none !important;
}
.m50 {
  margin: 50px 0;
}
.nav-btns {
  display: flex;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
.listing-header {
  background: #fff;
  color: #575757;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.loader {
  margin: 0 auto 20px;
  width: 100%;
  height: 25px;
  border-radius: 14px;
  border-bottom: 1px solid #fff;
  border-top: 1px solid #999;
  background: #ccc;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: inherit;
  width: 0%;
  border-radius: inherit;
  position: relative;
  overflow: hidden;
}

.progress-stripes {
  width: inherit;
  height: inherit;
  font-size: 180px;
  font-weight: bold;
  margin-top: -50px;
  letter-spacing: -14px;
}

.percentage {
  position: absolute;
  top: 0;
  right: 5px;
  font-weight: bold;
  font-size: 16px;
}
/* PURPLE */
.teal .progress-bar {
  background: #00bcbc;
}
.teal .progress-stripes {
  color: #00b4b4;
}
.teal .percentage {
  color: #eee;
}
.first-step {
  width: 20%;
}
.second-step {
  width: 60%;
}
.third-step {
  width: 90%;
}
.fourth-step {
  width: 100%;
}
.fifth-step {
  width: 90%;
}
.teal {
  color: #00b4b4;
}
.lookup-wrapper {
  text-align: center;
}
.lookup-svg {
  width: 300px;
  height: auto;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  margin-right: auto;
  margin: 0 auto;
}
.show-all-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: rgb(124, 124, 129);

  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 20px;
}
.show-all-btn:hover {
  background: #4d5967;
}
.custom-control-label:before {
  background-color: #dedede;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #00b4b4 !important;
}
input:focus {
  border-color: #00bcbc;
}
textarea:focus {
  border-color: #00bcbc;
}
</style>
  <style>
.style-chooser .vs__selected {
  background-color: #00bcbc !important;
  color: #fff !important;
}
.style-chooser .vs__dropdown-option--highlight {
  background-color: #00bcbc !important;
  color: #fff !important;
}
.style-chooser .vs__selected-options {
  padding: 10px;
}
.style-chooser .vs__dropdown-option .vs__dropdown-option--highlight {
  background-color: #00bcbc !important;
  color: #fff !important;
}
.style-chooser .vs__deselect {
  fill: #fff;
}
.style-chooser .vs__selected {
  border: none;
  font-weight: 300;
  padding: 2px 10px;
}
.style-chooser .vs__dropdown-toggle {
  padding: 0;
}
.style-chooser .vs__search {
  margin: 0;
  padding: 0;
}


.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
textarea {
  overflow: auto;
  resize: vertical;
}
button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
*,
::after,
::before {
  box-sizing: border-box;
}
user agent stylesheet textarea {
  box-sizing: border-box;
}
.success-header {
  background: #00b4b4;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  padding: 50px;
}
.success-header img {
  max-width: 200px;
}
.failure-header {
  background: #5a6877;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  padding: 50px;
}
.failure-header img {
  width: 200px;
}
.success-body {
  text-align: center;
  padding: 50px;
}
.failure-body {
  text-align: center;
  padding: 50px;
}
.failure-body a {
  color: #00bcbc;
}
.failure-body p {
  margin-bottom: 5px;
}
.orange {
  color: #f16232;
}
.header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.banner-bg {
  background-color: #00bcbc;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg id='c'%3E%3Cg id='b'%3E%3Cuse href='%23a' y='-1400'/%3E%3Cuse href='%23a' y='-1300'/%3E%3Cuse href='%23a' y='-1200'/%3E%3Cuse href='%23a' y='-1100'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-900'/%3E%3Cuse href='%23a' y='-800'/%3E%3Cuse href='%23a' y='-700'/%3E%3Cuse href='%23a' y='-600'/%3E%3Cuse href='%23a' y='-500'/%3E%3Cuse href='%23a' y='-400'/%3E%3Cuse href='%23a' y='-300'/%3E%3Cuse href='%23a' y='-200'/%3E%3Cuse href='%23a' y='-100'/%3E%3Cg stroke='%2300B4B4' stroke-width='0' id='a'%3E%3Cpath fill='%2300B4B4' d='M0 0l2100 40l-2100 40z'/%3E%3C/g%3E%3Cuse href='%23a' y='100'/%3E%3Cuse href='%23a' y='200'/%3E%3Cuse href='%23a' y='300'/%3E%3Cuse href='%23a' y='400'/%3E%3Cuse href='%23a' y='500'/%3E%3Cuse href='%23a' y='600'/%3E%3Cuse href='%23a' y='700'/%3E%3Cuse href='%23a' y='800'/%3E%3Cuse href='%23a' y='900'/%3E%3Cuse href='%23a' y='1000'/%3E%3Cuse href='%23a' y='1100'/%3E%3Cuse href='%23a' y='1200'/%3E%3Cuse href='%23a' y='1300'/%3E%3Cuse href='%23a' y='1400'/%3E%3Cuse href='%23a' y='1500'/%3E%3Cuse href='%23a' y='1600'/%3E%3Cuse href='%23a' y='1700'/%3E%3Cuse href='%23a' y='1800'/%3E%3Cuse href='%23a' y='1900'/%3E%3Cuse href='%23a' y='2000'/%3E%3Cuse href='%23a' y='2100'/%3E%3Cuse href='%23a' y='2200'/%3E%3Cuse href='%23a' y='2300'/%3E%3Cuse href='%23a' y='2400'/%3E%3Cuse href='%23a' y='2500'/%3E%3Cuse href='%23a' y='2600'/%3E%3Cuse href='%23a' y='2700'/%3E%3Cuse href='%23a' y='2800'/%3E%3C/g%3E%3Cuse href='%23b' x='-1' transform='scale(-1 1)'/%3E%3C/g%3E%3Cuse href='%23c' x='' transform='rotate(90 0 0)' style='transform-origin:center'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

.myTest .custom-control-input {
  margin-top: 0; /* Remove default offset */
}

/* Ensure label text aligns properly */
.myTest .custom-control-label {
  display: flex;
  align-items: center; /* Center the <small> text vertically within the label */
}

/* Adjust <small> styling if needed */
.myTest .form-text {
  margin-top: 0; /* Preserve original inline style */
  line-height: 1.5; /* Improve text alignment */
}
.search {
    margin-left: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: #4d5967;
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    cursor: pointer;
    max-height: 40px;
}

.product-school-select:focus {
  border-color: #00b4b4;
}
.custom-select:focus{
  border-color: #00b4b4;
}
</style>
  